import styled from "styled-components";

export const StyledResult = styled.p`
    text-align: center;
    font-size: 18px;
    width: 100%;
`;